import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { PanelCollapse } from '@bepure/tarkin';

const renderFAQSection = (id: string, section: { title: string, hasBackground: string, titleCentre: string }) => {
    const element = document.getElementById(id);
    if (element) {
        const component = (
            <>
                <div className={`text text--heading`}>{section.title}</div>
                {Array.from(element.children).map((input, index) => {
                    const panel = input as HTMLInputElement;
                    return (
                        <PanelCollapse title={panel.value} >
                            <div dangerouslySetInnerHTML={{ __html: panel.dataset.answer || '' }} />
                        </PanelCollapse>
                    );
                })}
            </>
        );
        ReactDOM.render(component, element);
    }
};

export default renderFAQSection;
